var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.requisicao)?_c('requisicao-form',{attrs:{"operacao":"A","errosPai":_vm.erros,"requisicao":_vm.requisicao,"naoPermiteAtualizar":_vm.naoPermiteAtualizar},on:{"salvar":function($event){return _vm.salvar($event)}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }